module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xMS4wMjUgMTIuOTc1VjE4Ljc1SDEyLjk3NVYxMi45NzVIMTguNzVWMTEuMDI1SDEyLjk3NVY1LjI1SDExLjAyNVYxMS4wMjVINS4yNVYxMi45NzVIMTEuMDI1WiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC45Ii8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/classroomObservation/Union.svg
// module id = k3QP
// module chunks = 4